import { createRouter, createWebHashHistory } from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import CategoryPage from '../components/CategoryPage.vue'
import LoginRegister from '../components/LoginRegister.vue'
import UserCenter from '../components/UserCenter.vue'
import ComicDetail from '../components/ComicDetail.vue'
import ComicReader from '../components/ComicReader.vue'
import VipPage from '../components/VipPage.vue'
import AboutUs from '../components/AboutUs.vue'
import CopyrightPage from '../components/CopyrightPage.vue'
import SearchPage from '../components/SearchPage.vue'
import CommunityPage from '../components/CommunityPage.vue'
import YouthProtectionPage from '../components/YouthProtectionPage.vue'
import RankingPage from '../components/RankingPage.vue'
import { youthStore, initYouthStore } from '../utils/youthContent'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld,
    meta: { 
      title: '道晗漫画平台 - 精彩漫画尽在此处',
      requiresAuth: false
    }
  },
  {
    path: '/category',
    name: 'Category',
    component: CategoryPage,
    meta: { 
      title: '漫画分类 - 道晗漫画平台',
      requiresAuth: false
    }
  },
  {
    path: '/community',
    name: 'CommunityPage',
    component: CommunityPage,
    meta: {
      title: '社区讨论 - 道晗漫画平台',
      requiresAuth: false
    }
  },
  {
    path: '/youth-protection',
    name: 'YouthProtectionPage',
    component: YouthProtectionPage,
    meta: {
      title: '青少年模式 - 道晗漫画平台',
      requiresAuth: false
    }
  },
  {
    path: '/ranking',
    name: 'RankingPage',
    component: RankingPage,
    meta: {
      title: '排行榜 - 道晗漫画平台',
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginRegister,
    // 确保该路径不需要登录认证
    meta: { 
      title: '登录/注册 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: UserCenter,
    // 需要登录认证
    meta: { 
      title: '个人中心 - 道晗漫画平台',
      requiresAuth: true 
    }
  },
  {
    path: '/comic/:id',
    name: 'ComicDetail',
    component: ComicDetail,
    // 漫画详情页不需要登录也可以查看
    meta: { 
      title: '漫画详情 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/reader/:id',
    name: 'Reader',
    component: ComicReader,
    meta: { 
      title: '漫画阅读 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/read/:comicId/:chapterId',
    name: 'ComicReader',
    component: ComicReader,
    meta: { 
      title: '漫画阅读 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/comic/:comicId/chapter/:chapterId',
    name: 'ComicReaderAlt',
    component: ComicReader,
    meta: { 
      title: '漫画阅读 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/vip',
    name: 'VipPage',
    component: VipPage,
    meta: { 
      title: 'VIP会员 - 道晗漫画平台',
      requiresAuth: false 
    } // 不需要登录也可以访问
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUs,
    meta: { 
      title: '关于我们 - 道晗漫画平台',
      requiresAuth: false 
    }
  },
  {
    path: '/copyright',
    name: 'CopyrightPage',
    component: CopyrightPage,
    meta: {
      title: '版权声明 - 道晗漫画平台',
      requiresAuth: false
    }
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: SearchPage,
    meta: { 
      title: '搜索结果 - 道晗漫画平台',
      requiresAuth: false 
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 前进/后退时恢复原滚动位置，其它导航一律回到页面顶部
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// 全局前置守卫，验证用户登录状态与青少年模式锁定状态
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '道晗漫画平台'

  // 初始化青少年模式状态（与服务端对账）
  initYouthStore()

  // 青少年模式锁定后，只允许访问青少年模式设置页（用于密码认证）
  if (youthStore.enabled && youthStore.locked && to.path !== '/youth-protection') {
    next('/youth-protection')
    return
  }
  
  // 判断是否需要验证登录（在需要验证的路由中添加meta: { requiresAuth: true }）
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 获取本地存储的token
    const token = localStorage.getItem('token')
    // 如果没有token，则跳转到登录页
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将要访问的路径作为参数，以便登录后跳转回原页面
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router 
